﻿document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    const target = e.target.closest(".js-print");

    if (target) {
      e.preventDefault();
      window.print();
    }
  });
});
